var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgStartDate = function SvgStartDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.768 10.261 1.292 1.185V14.4a.6.6 0 0 0 .6.6h.24a.6.6 0 0 0 .6-.6v-3.843l-1.44-1.184.387-2.207c.696.736 1.703 1.269 2.836 1.43.234.033.717-.014.717-.531 0-.518-.52-.63-.764-.683-.885-.187-1.608-.692-2.014-1.342l-.646-.948c-.258-.355-.646-.592-1.098-.592-.097 0-.177.015-.258.03-.08.014-.162.03-.258.03l-3.36 1.302v2.184a.6.6 0 0 0 .6.6h.092a.6.6 0 0 0 .6-.6V6.632l1.163-.414L8 11.36l-2.515-.381a.6.6 0 0 0-.654.387l-.065.178a.6.6 0 0 0 .503.804L9 12.726l.768-2.465zM13 2.5c0-.825-.675-1.5-1.5-1.5S10 1.675 10 2.5 10.675 4 11.5 4 13 3.325 13 2.5zM3 7h2v1H3V7zm2.5-2H2v1h3.5V5z"
  })));
};

export default SvgStartDate;